import React from "react"
import { StaticImage } from 'gatsby-plugin-image'
import { useTranslation } from "gatsby-plugin-react-i18next"

import { AppStoreButtons } from './app-store-buttons/AppStoreButtons'
import { FooterLinks } from './footer-links/FooterLinks'
import { SocialMediaLinks } from "./social-media-links/SocialMediaLinks"
import { Text } from "../Text/Text"


export const Footer = () => {
  const { t } = useTranslation("shared", {
    keyPrefix: "global_footer",
  });

  return (
    <footer className="bg-navy text-white">
      <div className="box-content px-5 py-11 mx-auto max-w-content-width md:py-24">
        <div className="text-center mx-auto mb-5 md:hidden">
          <StaticImage
            height={28}
            alt={t("logo_alt")}
            src="../../images/logos/logo.png"
            width={147}
          />
        </div>
        <div className="grid gap-5 md:grid-cols-[1fr_1fr_1fr_2fr] md:text-left">
          <FooterLinks 
            footerLinks={[
              {
                name: t("our_mission"),
                url: "/our-mission/"
               },
              {
                name: t("careers"),
                url: "https://globalus241.dayforcehcm.com/CandidatePortal/en-US/parachute"
              },
              {
                name: t("locations"),
                url: "/plasma-donation/location/"
              }
            ]}
            title={t("about")}
          />
          <FooterLinks 
            footerLinks={[
              { 
                name: t("parachute_app"),
                url: "/parachute-app/"
              },
              {
                name: t("member_experience"),
                url: "/how-it-works/"
              },
              {
                name: t("your_first_visit"),
                url: "/your-first-visit/"
              },
              {
                name: t("earning_with_parachute"),
                url: "/earning-with-parachute/"
              }
            ]}
            title={t("members")}
          />
          <FooterLinks 
            footerLinks={[
              {
                name: t("contact_us"),
                url: "/contact-us/"
              },
              {
                name: t("blog"),
                url: "/blog/"
              },
              {
                name: t("faqs"),
                url: "https://join-parachute.brainfish.ai/"
              },
              {
                name: t("take_our_quiz"),
                url: "/donor-assessment/"
              },
              {
                name: t("terms_of_service"),
                url: "/terms-of-service/"
              },
              {
                name: t("privacy_policy"),
                url: "/privacy-policy/"
              },
              {
                name: t("cardholder_agreement"),
                url: "https://duk1wjhw66vcw.cloudfront.net/join-parachute-card-holder-agreement.v3.pdf"
              }
            ]}
            title={t("resources")}
          />
          <div className="-order-1 text-center md:order-none md:text-left">
            <Text variant="small-subheader">{t("download_the_app_now")}</Text>
            <div className="mt-2.5">
              <Text variant="small-caption">{t("standard_text_data_fees_apply")}</Text>
            </div>
            <AppStoreButtons useQRCode={true} />
          </div>
          <div className="text-center md:flex md:col-[4/-1]">
            <SocialMediaLinks />
            <div className="ml-auto mt-5 md:mt-0">
              <Text variant="small-caption">{t("copyright", { year: new Date().getFullYear() })}</Text>
            </div>
          </div>
        </div>
        <div className="mt-11 text-center">
          <Text variant="small-caption">
            {t("legal")}
          </Text>
        </div>
      </div>

    </footer>
  )
}
